import React, { useLayoutEffect, useRef, useState } from "react";
import { observarRedimensionamento } from "../../../../utils/observarRedimensionamento";

export const ESCALA_MINIMA = 0.6;

export const escalaParaCaber = (larguraDisponivel: number, larguraTexto: number, escalaAtual: number) => {
  if (larguraDisponivel <= 0 || larguraTexto <= 0) {
    return escalaAtual;
  }
  const larguraNatural = larguraTexto / escalaAtual;
  const escala = Math.floor((larguraDisponivel / larguraNatural) * 100) / 100;
  return Math.max(ESCALA_MINIMA, Math.min(1, escala));
};

const tamanhoReduzido = (tamanho: React.CSSProperties["fontSize"], escala: number) => {
  if (escala === 1 || tamanho == null) {
    return tamanho;
  }
  const base = typeof tamanho === "number" ? `${tamanho}px` : tamanho;
  return `calc(${base} * ${escala})`;
};

interface Props {
  style: React.CSSProperties;
  children: string;
}

const ValorAjustavel = ({ style, children }: Props) => {
  const caixa = useRef<HTMLDivElement>(null);
  const texto = useRef<HTMLSpanElement>(null);
  const [escala, setEscala] = useState(1);

  useLayoutEffect(() => {
    const elementoCaixa = caixa.current;
    const elementoTexto = texto.current;
    if (!elementoCaixa || !elementoTexto) {
      return undefined;
    }
    // clientWidth/offsetWidth arredondam e escondem o excesso de fracao de pixel que ja trunca o texto
    const ajustar = () =>
      setEscala((atual) =>
        escalaParaCaber(elementoCaixa.getBoundingClientRect().width, elementoTexto.getBoundingClientRect().width, atual)
      );
    ajustar();
    return observarRedimensionamento(elementoCaixa, ajustar);
  }, [children]);

  return (
    <div
      ref={caixa}
      style={{
        ...style,
        fontSize: tamanhoReduzido(style.fontSize, escala),
        minWidth: 0,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      <span ref={texto}>{children}</span>
    </div>
  );
};

export default ValorAjustavel;
